export const PHONE = "918655358848";
export const wa = (text) => `https://wa.me/${PHONE}?text=${encodeURIComponent(text)}`;
export const WA_GENERAL = wa("Hi Go Trip Travels, I'd like to plan a trip.");

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; };
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const NAV = [
  { label: "Home", id: "home" },
  { label: "Domestic Trips", id: "domestic" },
  { label: "International Trips", id: "international" },
  { label: "Fleet Rentals", id: "fleet" },
  { label: "Contact Us", id: "contact" },
];

export const DOMESTIC = [
  { name: "Kashmir", code: "SXR", tag: "Snowy mountains · Dal Lake", img: "/images/kashmir.jpg", span: "md:col-span-2 lg:col-span-7 lg:row-span-2" },
  { name: "Ladakh", code: "IXL", tag: "High-altitude passes · Pangong Lake", img: "/images/ladakh.jpg", span: "lg:col-span-5" },
  { name: "Alibaug", code: "ABG", tag: "Coastal beach getaway", img: "/images/alibaug.jpg", span: "lg:col-span-5" },
  { name: "Jaipur", code: "JAI", tag: "Royal palaces & heritage", img: "/images/jaipur.jpg", span: "lg:col-span-4 lg:row-span-2" },
  { name: "Rishikesh", code: "RSK", tag: "Adventure & spiritual retreat", img: "/images/rishikesh.jpg", span: "lg:col-span-8" },
  { name: "Kerala", code: "COK", tag: "Lush backwaters & greenery", img: "/images/kerala.jpg", span: "lg:col-span-4" },
  { name: "Manali", code: "KUU", tag: "Scenic hill station", img: "/images/manali.jpg", span: "lg:col-span-4" },
];

export const FLEET = [
  { type: "Mini Bus", name: "Urbania", rate: 36, icon: "bus" },
  { type: "Mini Bus", name: "Traveller", rate: 27, icon: "bus" },
  { type: "SUV", name: "Innova", rate: 17, icon: "suv" },
  { type: "SUV", name: "Ertiga", rate: 15, icon: "suv" },
  { type: "Sedan", name: "Swift Dzire", rate: 13, icon: "car" },
  { type: "Sedan", name: "Aura", rate: 13, icon: "car" },
];

export const INTERNATIONAL = [
  { name: "Bali", country: "Indonesia", img: "/images/bali.jpg" },
  { name: "Maldives", country: "Indian Ocean", img: "/images/maldives.jpg" },
  { name: "Sri Lanka", country: "Island Nation", img: "/images/srilanka.jpg" },
  { name: "Dubai", country: "UAE", img: "/images/dubai.jpg" },
];

export const HERO_SLIDES = [
  { img: "/images/hero2.jpg", label: "Ladakh", code: "IXL" },
  { img: "/images/hero1.jpg", label: "Kerala", code: "COK" },
  { img: "/images/hero3.jpg", label: "Jaipur", code: "JAI" },
];

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");
